export default __webpack_public_path__ + "static/media/logo2.20491827.png";